import { render, staticRenderFns } from "./TransferDirectionBtn.vue?vue&type=template&id=3595a91e&scoped=true"
import script from "./TransferDirectionBtn.vue?vue&type=script&lang=ts"
export * from "./TransferDirectionBtn.vue?vue&type=script&lang=ts"
import style0 from "./TransferDirectionBtn.vue?vue&type=style&index=0&id=3595a91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595a91e",
  null
  
)

export default component.exports